module.exports = __webpack_public_path__ + "img/gallery_layout1.e25eefaa.png";